module.exports = __webpack_public_path__ + "img/mainPicture.f10b5e5f.png";